import React from 'react';
import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Row,
  Space,
  Statistic,
  Typography,
} from 'antd';
import {
  BarChartOutlined,
  CopyOutlined,
  PlusCircleFilled,
  ShareAltOutlined,
} from '@ant-design/icons';
import { formatCurrency } from 'utils/number';

const { Text, Title } = Typography;

const DashboardMobile = ({ viewModel }) => {
  const {
    messageContextHolder,
    quickActions,
    getActionColor,
    orderNewCount,
    orderShippingCount,
    orderCancelCount,
    orderAmount,
    storeLink,
    storeDomain,
    onQuickActionClick,
    onViewReport,
    onCreateOrder,
    onCopyStoreLink,
    onShareStoreLink,
  } = viewModel;

  return (
    <>
      {messageContextHolder}

      <Row gutter={[12, 12]} style={{ marginInline: 0 }}>
 
      <Col span={24}>
        <Card size='small'>
          <Row justify='space-between' align='middle'>
            <Col>
              <Title level={5}>DOANH THU HÔM NAY</Title>
            </Col>
            <Col>
              {/* <Button
                type='link'
                icon={<BarChartOutlined />}
                onClick={onViewReport}
              >
                Xem báo cáo
              </Button> */}
            </Col>
          </Row>

          <Title level={2}>{formatCurrency(orderAmount)}</Title>

          <Divider />

          <Row gutter={8}>
            <Col span={8}>
              <Statistic title='Đơn hàng mới' value={orderNewCount} />
            </Col>
            <Col span={8}>
              <Statistic title='Chờ giao hàng' value={orderShippingCount} />
            </Col>
            <Col span={8}>
              <Statistic title='Đơn hủy' value={orderCancelCount} />
            </Col>
          </Row>
        </Card>
      </Col>

      <Col span={24}>
        <Card size='small'>
          <Row gutter={[8, 12]}>
            {quickActions.map((item) => (
              <Col span={6} key={item.key} style={{ display: 'flex' }}>
                <Button
                  type='text'
                  block
                  style={{
                    height: '100%',
                    minHeight: 92,
                    whiteSpace: 'normal',
                    paddingInline: 4,
                    paddingBlock: 6,
                    display: 'flex',
                    alignItems: 'stretch',
                    justifyContent: 'center',
                  }}
                  onClick={() => onQuickActionClick(item.path)}
                >
                  <Space direction='vertical' align='center' size={2} style={{ width: '100%', justifyContent: 'flex-start' }}>
                    <Avatar size={40} icon={item.icon} style={{ backgroundColor: getActionColor(item.tone) }} />
                    <Text
                      style={{
                        textAlign: 'center',
                        lineHeight: 1.2,
                        fontSize: 12,
                        minHeight: 29,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                      }}
                    >
                      {item.label}
                    </Text>
                  </Space>
                </Button>
              </Col>
            ))}
          </Row>

          <Divider />

          <Button
            type='primary'
            block
            icon={<PlusCircleFilled />}
            onClick={onCreateOrder}
          >
            Tạo đơn hàng
          </Button>
        </Card>
      </Col>

      <Col span={24}>
        <Card size='small'>
          <Row gutter={12} align='middle'>
            <Col flex='auto'>
              <Space direction='vertical' size={4} style={{ width: '100%' }}>
                <Title level={4} style={{ margin: 0 }}>Cửa hàng online của bạn</Title>
                <Text>
                  Hãy chia sẻ link cửa hàng online đều đặn trên Facebook, Zalo để có thật nhiều đơn!
                </Text>
                {storeLink ? (
                  <Typography.Link href={storeLink} target='_blank'>
                    {storeDomain}
                  </Typography.Link>
                ) : (
                  <Text type='secondary'>Đang tải liên kết cửa hàng...</Text>
                )}
                <Row gutter={8}>
                  <Col span={12}>
                    <Button block icon={<CopyOutlined />} onClick={onCopyStoreLink} disabled={!storeLink}>
                      Sao chép
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button type='primary' block icon={<ShareAltOutlined />} onClick={onShareStoreLink} disabled={!storeLink}>
                      Chia sẻ
                    </Button>
                  </Col>
                </Row>
              </Space>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
    </>
  );
};

export default DashboardMobile;
